import { paths } from "~/router/paths";

// Pages for logged-out users. A dead session must not redirect anyone away
// from here, and there is no account to fetch on them.
export const signOutExcludedPaths: string[] = [
  paths.auth.store_login,
  paths.auth.login,
  paths.auth.register,
  paths.auth.forgot,
];

export const isGuestPath = (pathname: string): boolean =>
  signOutExcludedPaths.some((path) => new RegExp(`^${path}`).test(pathname));

// Pages that hide the upsell banner. Checkout and settings need a logged-in
// account, so a dead session there must still sign out: they are deliberately
// not guest pages.
export const excludePaths: string[] = [
  ...signOutExcludedPaths,
  paths.checkout.index.replace(":id", ""),
  paths.settings.index,
];
